import type { ReactNode } from 'react';
import { ConditionNodeRenderer } from './condition-node';
import { SegmentPopover } from './renderers/segment-condition';

type SegmentDetailsPopoverProps = {
  segmentId: number;
  workspaceId: number;
  /** The trigger's name, for a trigger whose content does not say it — an icon. */
  triggerLabel: string;
  /** What the trigger shows, drawn inside a button. */
  children: ReactNode;
};

/**
 * The hover card a segment condition opens, for a segment named anywhere
 * else: its type, its conditions, its size and a link to it.
 *
 * The segment is read only once the card first opens, so a table of these
 * costs a request per segment somebody looks at rather than one per row.
 *
 * It opens on focus as well as hover, so it can be reached without a mouse,
 * and Escape closes the card and nothing around it: it is as likely to sit
 * in a drawer or a modal as on a page, and Pluma's popovers would otherwise
 * close those with it.
 */
export function SegmentDetailsPopover({ segmentId, workspaceId, triggerLabel, children }: SegmentDetailsPopoverProps) {
  return (
    <SegmentPopover
      segmentId={segmentId}
      workspaceId={workspaceId}
      renderCondition={ConditionNodeRenderer}
      triggerLabel={triggerLabel}
      popoverProps={{
        shouldTriggerOnFocus: true,
        floatingPluginOptions: { dismiss: { bubbles: { escapeKey: false } } },
      }}
    >
      {children}
    </SegmentPopover>
  );
}
